import { useGetApiDataAsMutate, usePostApiData } from "shared/datalayer";
import CommonApi from "shared/enums/CommonApi";
import { useCopies } from "shared/hooks/useCopies";
import { ApiFieldAsset } from "shared/types/ApiFieldAsset";
import { successToast } from "shared/utils/toastNotification";
import { downloadFileUsingBase64Data, getToken } from "../../../utils";
import PublicApi from "../../../enums/PublicApi";
import { MimeTypeEnum } from "../../../utils/enums";

export function useCreateSchemaFieldAsset() {
  const copies = useCopies();
  const token = getToken();
  const apiUrl = token ? CommonApi.CREATE_SCHEMA_FIELD_ASSET : PublicApi.CREATE_SCHEMA_FIELD_ASSET;
  return usePostApiData<ApiFieldAsset, FormData>(apiUrl, {
    clientOptions: { trimAndRemoveNull: false },
    onSuccess: () => successToast(copies.get("resource.asset.upload.msg"))
  });
}

export function useDownloadApiResourceAsset(args: { fileName: string; fileContentType?: MimeTypeEnum }) {
  const copies = useCopies();
  return useGetApiDataAsMutate<any>(CommonApi.DOWNLOAD_API_RESOURCE_ASSET, {
    onSuccess: data => {
      downloadFileUsingBase64Data({ base64Data: data, fileName: args.fileName, contentType: args.fileContentType });
      successToast(copies.get("file.downloaded.successfully"));
    }
  });
}
